/* ============================================================
   PDP — True Fit placement

   Does one thing: moves the True Fit mount out of the Size fieldset
   and re-parents it after the LAST variant option group, so on the
   dress pant it lands below Inseam rather than between Size and
   Inseam. On products where Size is the only option — the suit jacket
   — last group IS Size, so the position is unchanged.

   WHY JAVASCRIPT
   The mount is emitted inside the Size fieldset by ms-pdp-main.liquid
   (it is inside the `if is_size` branch). Inseam is a sibling
   fieldset, so no amount of CSS order/flex can move the mount across
   that boundary — order only reorders siblings within one flex
   container. The node has to actually be re-parented.

   WHY IT MOVES THE NODE RATHER THAN RE-CREATING IT
   appendChild/after() relocate the existing element with its children
   and listeners intact, so this is safe whether True Fit has already
   rendered into it or not. It is deliberately NOT cloned — a clone
   would drop True Fit's event handlers and leave a dead widget.

   WHAT THIS FILE NO LONGER DOES — READ BEFORE RE-ADDING
   Three earlier versions tried to shrink the widget to a compact text
   link by hiding True Fit's block and driving it from a theme-built
   button. All three failed, in instructive ways:

     1. Hiding the mount before first paint (position/opacity) — True
        Fit rendered nothing at all. It runs its own visibility check,
        not just a box measurement.
     2. `*:not(:has(button, a))` to strip the advice copy — their CTA
        is neither a <button> nor an <a>, so nothing was excepted,
        every element matched, and the whole block disappeared.
     3. A JS control-finder looking for button/a/[role=button] — same
        wrong assumption, so it never found a control, never
        collapsed, and silently removed its own link after 20s.

   The common thread is guessing at True Fit's internal markup. Do not
   attempt (1)-(3) again without first reading the real structure:

     document.querySelector('[data-ms-fitapp]').innerHTML

   Until then this file stays placement-only and the widget renders
   exactly as True Fit ships it.
   ============================================================ */
(function () {
  'use strict';

  function place(mount) {
    if (mount.getAttribute('data-ms-fit-placed')) return;

    var form = mount.closest('form');
    if (!form) return;

    /* [data-ms-option] is on the native variant fieldsets only. Plain
       .ms-opt would also catch the Style and Color sibling rows, which
       sit OUTSIDE the form and are not option groups at all. */
    var groups = form.querySelectorAll('[data-ms-option]');
    if (!groups.length) return;

    var last = groups[groups.length - 1];
    /* Already in the right place (Size is the only option). */
    if (last.contains(mount) && mount.parentNode === last) {
      if (last === groups[groups.length - 1] && groups.length === 1) {
        mount.setAttribute('data-ms-fit-placed', '1');
        return;
      }
    }

    mount.setAttribute('data-ms-fit-placed', '1');
    last.insertAdjacentElement('afterend', mount);
  }

  function init() {
    document.querySelectorAll('[data-ms-fitapp]').forEach(place);
  }

  /* barba swaps <main> on client-side navigation. ms-pdp.js survives
     that because the section emits its <script> inside <main> and the
     browser re-executes it on insertion; this file is loaded once from
     <head> and would not re-run. A debounced body observer covers it —
     place() is idempotent via the data attribute, so repeat calls are
     free. */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      init();
    });
  }

  function start() {
    init();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', init);
})();
